import { createSlice } from "@reduxjs/toolkit";
import { getVolumetricList } from "../../reduxApi/admin/VolumetricRedux";





const VolumetricSlice = createSlice({
    name: 'volumetric',
    initialState: {
        status: 'idel',
        isFiltered: false,
        volumetric: [],
    },
    reducers: {
        setVolumetricFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteVolumetricAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.volumetric.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.volumetric.splice(index, 1);
                }
            });
        },
        updateVolumetricAction: (state, action) => {
            const index = state.volumetric.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.volumetric.splice(index, 1, action.payload)
            }
        },
        addVolumeMatrixAction: (state, action) => {
            console.log("action--->", action.payload);

            const temp = action.payload;
            console.log("temp", temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID", temp.ROWID);

            state.volumetric.unshift(temp); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getVolumetricList.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(getVolumetricList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("getVolumetricList fullfilled ",action.payload);
                state.volumetric = action.payload || [];
            })
            .addCase(getVolumetricList.rejected, (state) => {
                state.status = 'failed';
            });
    }
})
export const { deleteVolumetricAction,addVolumeMatrixAction,updateVolumetricAction, setVolumetricFilteredStatus} = VolumetricSlice.actions
export default VolumetricSlice.reducer